module.exports = __webpack_public_path__ + "img/community.696442a3.svg";